import React from "react"
import { withRouter } from "react-router-dom"
import Base from "./Base"
import InvoiceTable from "../../Components/Invoices/InvoiceTable"
import { } from "antd"
import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"

class EmittedInvoices extends React.Component {

    render() {
        if(this.props.login.user_data.estado_usuario==='INACTIVO'|| this.props.login.user_data.estado_usuario === 'INCOMPLETO'){
            this.props.history.push('/')
            return null
        }else{
        return (
            <Base
                title="Facturas Emitidas"
                selected="facturas-emitidas"
            >
                <InvoiceTable
                    dashboard={false}
                />
            </Base>

        );
    }}
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EmittedInvoices));